import { CocosController } from "./cocosController";

export class CocosWidget {
    controller: CocosController;
    parent: HTMLElement;

    applyFloor = () => {
        this.controller.applyFloor();
    }
    toggleSnap = () => {
        this.controller.toggleSnap();
    }
    toggleAngleSnap = () => {
        this.controller.toggleAngleSnap();
    }
    closeFrontView = () => {
        this.controller.closeFrontView();
    }
    swapFrontView = () => {
        this.controller.swapFrontView();
    }
    toogleFrontViewDrawMode = () => {
        this.controller.toogleFrontViewDrawMode();
    }

    handleMenu = (event: any) => {
        (this.controller as any)[event.currentTarget.id]();
    }

    handleShortCut = (event: any) => {
        setTimeout(() =>{          
            if (event.key === 's' || event.key ==='a') {
                this.updateSnap();
            }
        }, 100);
    }

    EventTab = [
        {id: "snap", handler: this.toggleSnap},
        {id: "snapAngle", handler: this.toggleAngleSnap},
        {id: "closeFrontView", handler: this.closeFrontView},
        {id: "swapFrontview", handler: this.swapFrontView},
        {id: "frontViewDrawMode", handler: this.toogleFrontViewDrawMode},
        {id: "applyFloor", handler: this.handleMenu},
        {id: "applyJoint", handler: this.handleMenu},
        {id: "applyCeiling", handler: this.handleMenu},
        {id: "applyStep", handler: this.handleMenu},
        {id: "applyCounterStep", handler: this.handleMenu},
        {id: "applyLimon", handler: this.handleMenu},
        {id: "applyStairBack", handler: this.handleMenu},
        {id: "applyAll", handler: this.handleMenu},
        {id: "replaceCoatingArea", handler: this.handleMenu},
        {id: "applyJointCoatingArea", handler: this.handleMenu},
        {id: "applyCleatCoatingArea", handler: this.handleMenu},
        {id: "applyWall", handler: this.handleMenu},
        {id: "applyJointWall", handler: this.handleMenu},
        {id: "applyGeoPrim", handler: this.handleMenu},
        {id: "applyJointGeoPrim", handler: this.handleMenu},
    ];


    constructor(parent: HTMLElement, rhinovFormat: any, rightPanel: boolean , planId: number, autocache: boolean, user: any, modulepath: any) {
        this.parent = parent;
        this.controller = new CocosController(parent, rhinovFormat, rightPanel, planId, autocache, user, modulepath);
        this.parent.insertAdjacentHTML('beforeend', this.html());
        setTimeout(() => {
            this.setListener();
        }, 50);
    }

    updateSnap() {
        let snap = document.getElementById('snap');
        let notSnap = document.getElementById('notSnap');
        let notSnapAngle = document.getElementById('notSnapAngle');
        let snapAngle = document.getElementById('snapAngle');
        if (snap && snapAngle) {
            snap.classList[!this.controller.displaySnap() ? "add" : "remove"]('hide');
            snapAngle.classList[!this.controller.displayAngleSnap() ? "add" : "remove"]('hide');
        }

        if (notSnap) {
            notSnap.classList[this.controller.snapEnabled() ? "add" : "remove"]('hide');
        }
        if (notSnapAngle) {
            notSnapAngle.classList[this.controller.angleSnapEnabled() ? "add" : "remove"]('hide');
        }
    }

    ToggleSnap(): string {
        return `
            <div id="snap" ng-click="toggleSnap()" class="${this.controller.displaySnap() ? "" : "hide"}" title="Aimant" style="position:absolute; cursor: pointer; top: 6px; left: 12px;">\
                <span class="fa-stack">\
                    <i class="fas fa-stack-1x fa-magnet" style="line-height: 2em;"></i>\
                    <i id="notSnap" class="fas fa-ban fa-stack-2x ${this.controller.snapEnabled() ? "hide" : ""}" style="color:Tomato"></i>\
                </span>\
            </div>
        `;
    }

    ToggleSnapAngle(): string {
        return `
            <div id="snapAngle" ng-click="toggleAngleSnap()" class="${this.controller.displayAngleSnap() ? "" : "hide"}" title="Aimant angle" style="position:absolute; cursor: pointer; top: 6px; left: 48px;">\
                <span class="fa-stack">\
                    <i class="fas fa-stack-1x" style="font-size: 1.5em;">A</i>\
                    <i id="notSnapAngle" class="fas fa-ban fa-stack-2x ${this.controller.angleSnapEnabled() ? "hide" : ""} style="color:Tomato"></i>\
                </span>\
            </div>
        `;
    }

    closeFrontViewHtml(): string {
        return `
            <div id="closeFrontView" ng-click="closeFrontView()" title="Fermer vue de face" style="position:absolute; cursor: pointer; top: 6px; right: 48px;">\
                <span class="fa-stack">\
                    <i class="fas fa-stack-1x fa-times" style="line-height: 2em;"></i>\
                </span>\
            </div>
        `;
    }

    swapFrontViewHtml(): string {
        return `
            <div id="swapFrontview" ng-click="swapFrontView()" title="Changer de côté vue de face" style="position:absolute; cursor: pointer; top: 6px; right: 84px;">\
                <span class="fa-stack">\
                    <i class="fas fa-stack-1x fa-arrows-alt-v" style="line-height: 2em;"></i>\
                </span>\
            </div>
        `;
    }

    ToggleFrontViewDrawModeHtml(): string {
        return `
            <div id="frontViewDrawMode" ng-click="toogleFrontViewDrawMode()" title="Changer la méthode de tracé" style="position:absolute; cursor: pointer; top: 6px; right: 124px;">\
                ${!this.controller.frontViewDrawMode() ? `
                    <span class="fa-stack">
                        <i class="fas fa-stack-1x fa-draw-polygon" style="line-height: 2em;"></i>
                    </span>` :
                    `
                    <span class="fa-stack">\
                        <i class="far fa-stack-1x fa-square" style="line-height: 2em;"></i>\
                    </span>`}
            </div>
        `;
    }

    ContextualMenu(): string {
        return `
            <span id="ContextualMenu" style="position:absolute;top:200px;left:50px">
                <ul id="ContextualMenuRoom" class="dropdown-menu" style="display: none; width: 200px">
                    <li id="applyFloor" class="primaryLabel" ng-click="applyFloor()">Appliquer au sol</li>
                    <li id="applyJoint" class="primaryLabel" ng-click="applyJoint()">Appliquer au joint</li>
                    <li id="applyCeiling" class="primaryLabel" ng-click="applyCeiling()">Appliquer au plafond</li>
                </ul>
                <ul id="ContextualMenuStair" class="dropdown-menu" style="display: none; width: 200px">
                    <li id="applyStep" class="primaryLabel" ng-click="applyStep()">Appliquer aux marches</li>
                    <li id="applyCounterStep" class="primaryLabel" ng-click="applyCounterStep()">Appliquer aux contre marches</li>
                    <li id="applyLimon" class="primaryLabel" ng-click="applyLimon()">Appliquer au limon</li>
                    <li id="applyStairBack" class="primaryLabel" ng-click="applyStairBack()">Appliquer au dos</li>
                    <li id="applyAll" class="primaryLabel" ng-click="applyAllStair()">Appliquer à tout</li>
                </ul>\
                <ul id="ContextualMenuCoatingArea" class="dropdown-menu" style="display: none; width: 200px">
                    <li id="replaceCoatingArea" class="primaryLabel" ng-click="replaceCoatingArea()">Remplacer</li>
                    <li id="applyJointCoatingArea" class="primaryLabel" ng-click="applyJointCoatingArea()">Appliquer au joint</li>
                    <li id="applyCleatCoatingArea" class="primaryLabel" ng-click="applyCleatCoatingArea()">Appliquer aux tasseaux</li>
                </ul>\
                <ul id="ContextualMenuWall" class="dropdown-menu" style="display: none; width: 200px">
                    <li id="applyWall" class="primaryLabel" ng-click="applyWall()">Appliquer au mur</li>
                    <li id="applyJointWall" class="primaryLabel" ng-click="applyJointWall()">Appliquer au joint</li>
                </ul>\
                <ul id="ContextualMenuGeoPrim" class="dropdown-menu" style="display: none; width: 200px">
                    <li id="applyGeoPrim" class="primaryLabel" ng-click="applyGeoPrim()">Appliquer à la primitive</li>
                    <li id="applyJointGeoPrim" class="primaryLabel" ng-click="applyJointGeoPrim()">Appliquer au joint</li>
                </ul>\
            </span>
        `;
    }

    setListener() {
        this.EventTab.forEach(({id, handler}) => {
            let element = document.getElementById(id);
            if (element) {
                element.addEventListener('click', handler);
            }
        })
        document.addEventListener('keydown', this.handleShortCut, true);
    }

    removeListener() {
        this.EventTab.forEach(({id, handler}) => {
            let element = document.getElementById(id);
            if (element) {
                element.removeEventListener('click', handler);
            }
        })
        document.removeEventListener('keydown', this.handleShortCut, true);
    }

    frontViewHtml(): string {
        return `
            <div id="frontViewButtons" ${this.controller.isFrontView() ? "" : `class="hide"`}>
                ${this.closeFrontViewHtml()}
                ${this.swapFrontViewHtml()} 
                ${this.ToggleFrontViewDrawModeHtml()}
            </div>
        `
    }

    html(): string {
        var html = "";
        var superGame = document.createElement('div');
        superGame.id = 'superGame';
        this.parent.appendChild(superGame);
        // //Set id of element to cocos-div
        superGame.style.position = 'relative';
        //Append canvas for cocos context
        var canvas = document.createElement('canvas');
        canvas.id = 'gameCanvas';
        superGame.appendChild(canvas);
        html += this.ToggleSnap() + this.ToggleSnapAngle() + this.frontViewHtml() + this.ContextualMenu();
        return html;
    }

    destroy() {
        this.removeListener();
        this.controller.destroy();
    }
}